import { Dropdown, Field } from 'Components/Core';
import { WorksheetBatchUpdateQueryField } from 'Components/WorksheetBatchUpdate';
import { FilterTestStatus } from 'Data/Search';
import { hasNonEmptyValue } from 'Lib/Any';

/**
 * Query for tests by worksheet status
 */
export const WorksheetBatchUpdateTestStatusQueryField: WorksheetBatchUpdateQueryField = {
  entryComponent: (
    <Field
      input={<Dropdown />}
      label="Test Status"
      options={[
        { label: 'All statuses', value: FilterTestStatus.allStatuses },
        { label: 'Checked or reported', value: FilterTestStatus.checkedOrReported },
        { label: 'Ready for checking', value: FilterTestStatus.readyForChecking },
        { label: 'Incomplete', value: FilterTestStatus.incomplete },
      ]}
    />
  ),
  // The default uses the FilterTestStatus value directly and so the value may be a string
  valueToParam: (option) => option?.value ?? option,
  paramToValue: (urlParam) => (hasNonEmptyValue(urlParam) ? { value: urlParam, label: urlParam } : undefined),
};
